import React, { memo } from 'react';
import { StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'María González',
    age: 34,
    location: 'Buenos Aires, Argentina',
    quote: 'Compré mi Air Fryer hace meses y solo hacía papas fritas. Con este libro descubrí un mundo nuevo. Las recetas son súper fáciles y los ingredientes los tengo siempre en casa. ¡Mi familia está encantada!'
  }, {
    name: 'Carmen López',
    age: 42,
    location: 'Ciudad de México, México',
    quote: 'Trabajo todo el día y no tengo tiempo para cocinar. Estas recetas de 15 minutos me salvaron la vida. Ahora comemos rico, casero y sin ensuciar casi nada la cocina.'
  }, {
    name: 'Lucía Fernández',
    age: 29,
    location: 'Madrid, España',
    quote: 'Quería comer más sano pero odiaba las dietas aburridas. El pollo queda súper jugoso y crujiente sin una gota de aceite. Los postres del bono son increíbles.'
  }, {
    name: 'Andrea Ramírez',
    age: 38,
    location: 'Bogotá, Colombia',
    quote: 'Lo mejor es que a mis hijos les encanta. Hago nuggets saludables, verduras que ahora sí se comen y hasta postres rápidos. La tabla de tiempos y temperaturas la tengo pegada en la heladera.'
  }, {
    name: 'Valentina Torres',
    age: 45,
    location: 'Santiago, Chile',
    quote: 'Antes usaba la Air Fryer una vez por semana, ahora la uso todos los días. Las instrucciones son clarísimas y las recetas no fallan. Vale cada centavo.'
  }];
  return <section className="py-20 px-4 bg-cream" data-id="element-184">
      <div className="max-w-6xl mx-auto" data-id="element-185">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-16 text-warm-900" data-id="element-186">
          Miles de personas ya están descubriendo lo fácil y rápido que es
          cocinar
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-187">
          {testimonials.map((t, index) => <div key={index} className="bg-white border border-warm-400 rounded-2xl p-6 flex flex-col h-full shadow-sm" data-id="element-188">
              <div className="flex gap-1 mb-4" data-id="element-189">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-5 h-5 fill-primary text-primary" data-id="element-190" />)}
              </div>
              <p className="text-warm-800 italic mb-6 flex-1" data-id="element-191">"{t.quote}"</p>
              <div className="border-t border-warm-400 pt-4" data-id="element-192">
                <p className="font-bold text-warm-900" data-id="element-193">
                  {t.name}, {t.age}
                </p>
                <p className="text-sm text-warm-700" data-id="element-194">{t.location}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}